require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-weiden-am-see.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-weiden-am-see");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-weiden-am-see!./.cache/json/betreuungseinrichtungen-neusiedl-weiden-am-see.json
// module id = 967
// module chunks = 231608221292675